import React from 'react';
import PropTypes from 'prop-types';

function UiLock({ visible }) {
    const styles = { display: visible ? 'block' : 'none' };
    return (
        <div
            className="ui-lock loading"
            style={styles}
        >
            {window.uiLockText && (<div className='ui-lock-text'>{window.uiLockText}</div>)}
        </div>
    );
}

UiLock.propTypes = {
    visible: PropTypes.bool.isRequired
};

export { UiLock };
